import { Inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

import * as StartActions from '../actions/start.actions';
import * as VoucherActions from '../actions/voucher.actions';
import * as AuthActions from '../actions/auth.actions';
import * as InviteActions from '../actions/invite.actions';
import * as MgmActions from '../actions/mgm.actions';
import {getActiveBusiness, getActiveBusinessId, getUser, isCompanyType} from 'src/app/store/selectors/auth.selectors';
import { Action, Store } from '@ngrx/store';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { CookieConfig } from '../../../config/cookie-config';
import { applyAccessRedirect } from '../../utils/access-redirect';

@Injectable()
export class StartEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private cookieService: CookieService,
    @Inject(DOCUMENT) readonly document: Document
  ) {}

  get window(): Window { return this.document.defaultView; }

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StartActions.init),
      withLatestFrom(this.store.select(getUser)),
      switchMap(([{token}, user]: any) => {
        if (user) {
          return of(StartActions.initSuccess()) as any;
        }
        return of(AuthActions.meRetrieve({ token }));
      })
    ) as any
  );

  afterMeRetrieve$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.meSuccess),
      withLatestFrom(this.store.select(getActiveBusiness)),
      withLatestFrom(this.store.select(getActiveBusinessId)),
      switchMap(([[me, activeAccount], businessId]) => {
        this.cookieService.set(environment.COOKIE_BID, businessId, CookieConfig.getExpireDate(), '/', environment.COOKIE_DOMAIN, true);
        this.cookieService.set(environment.COOKIE_BT,
          me.user.typeBusiness, CookieConfig.getExpireDate(), '/', environment.COOKIE_DOMAIN, true);

        if (this.window) {
          applyAccessRedirect(me.user, this.window.location.pathname);
        }

        return of(StartActions.initSuccess());
      })
    )
  );

  afterInitSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StartActions.initSuccess),
      withLatestFrom(this.store.select(isCompanyType)),
      switchMap(([, isCompany]) => {
        return isCompany
          ? of(VoucherActions.retrieve(), InviteActions.retrieve())
          : of();
        }
      )
    )
  );

  afterRetrieveInvites$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InviteActions.retrieveSuccess),
      switchMap(({ inviteMember }) => of(
        MgmActions.retrieve({ id: inviteMember.mgmId }),
      ))
    )
  );
}
